import { useCallback, useState } from 'react'
import {
  fetchAllProjectClosingStatus,
  fetchSelectedProjectClosingStatus,
  ProjectClosingStatusResponse,
  ProjectClosingStatusRow,
} from '../projectClosingStatus'
import { ProjectClosingStatusSearchCondition } from './useSearchCondition'

export const useProjectClosingStatusData = () => {
  const [data, setData] = useState<ProjectClosingStatusRow[]>([])

  const fetchRecords = useCallback(
    async (
      start: string,
      end: string,
      searchCondition: ProjectClosingStatusSearchCondition
    ) => {
      setData([])
      const response = (
        await fetchSelectedProjectClosingStatus(start, end, searchCondition)
      ).json as ProjectClosingStatusResponse[]

      if (!response) return

      const rows = response.map(data => ({
        uuid: data.uuid,
        division: data.division,
        project: {
          name: data.project.displayName,
          iconUrl: data.project.iconUrl || undefined,
        },
        projectStatus: data.project.status,
        startDate: data.project.scheduledDate.startDate,
        endDate: data.project.scheduledDate.endDate,
        projectManager: data.projectManager,
        closingStatus: data.closingStatus,
        userCount: data.userCount,
        approvedUserCount: data.approvedUserCount,
        closingDate: data.closingDate,
        closer: data.closer,
      })) as ProjectClosingStatusRow[]
      setData(rows)
    },
    []
  )
  return { data, fetchRecords }
}
